import { ThemeColors } from '~/themes/colors'

interface EmptyStateColors {
  Icon: ThemeColors
  PrimaryText: {
    FontColor: ThemeColors
  }
  SecondaryText: {
    FontColor: ThemeColors
  }
}
export const EmptyStateColors: EmptyStateColors = {
  Icon: {
    default: 'gray.600',
  },
  PrimaryText: {
    FontColor: {
      default: 'gray.800',
    },
  },
  SecondaryText: {
    FontColor: {
      default: 'gray.800',
    },
  },
}
